import { getToken } from "@tamagui/core";
import { jsx } from "react/jsx-runtime";
function adaptExternalIcon(IconComponent) {
  const AdaptedIcon = ({ size = 24, color, "aria-label": ariaLabel, ...props }) => {
    const tokenValue = color ? getToken(color, "color") : void 0, iconColor = tokenValue !== void 0 ? String(tokenValue) : void 0;
    return /* @__PURE__ */ jsx(IconComponent, { size, color: iconColor, "aria-label": ariaLabel, ...props });
  };
  return AdaptedIcon.displayName = `AdaptedIcon(${IconComponent.displayName || IconComponent.name || "Icon"})`, AdaptedIcon;
}
export {
  adaptExternalIcon
};
